import { memo, useState } from 'react';
import styles from './Checkbox.module.scss';

function Checkbox({ checked, title, onChange }) {
    const [localChecked, setLocalChecked] = useState(checked ? true : false);

    const handleOnClick = () => {
        if (onChange) onChange(!localChecked);
        setLocalChecked((pre) => !pre);
    };

    return (
        <div className={styles.checkbox} onClick={handleOnClick}>
            {localChecked ? (
                <i
                    className="fa-regular fa-square-check"
                    style={{ color: '#1e3050' }}
                ></i>
            ) : (
                <i
                    className="fa-regular fa-square"
                    style={{ color: '#1e3050' }}
                ></i>
            )}
            <label className={styles.title}>{title}</label>
        </div>
    );
}

export default memo(Checkbox);
